(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupController', CustomerGroupController);

    CustomerGroupController.$inject = ['$scope', '$state', 'CustomerGroup', 'PersonInfo', 'ParseLinks', 'AlertService', 'entity', 'CustomerGroupCustom', '$mdDialog', '$translatePartialLoader'];

    function CustomerGroupController($scope, $state, CustomerGroup, PersonInfo, ParseLinks, AlertService, entity, CustomerGroupCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.customerGroup = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;

        initDefault();
        loadAll();

        function initDefault() {

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');


        }

        function save() {
            vm.isSaving = true;


            if (vm.customerGroup.id !== null) {
                CustomerGroup.update(vm.customerGroup, onSaveSuccess, onSaveError);
            } else {

                CustomerGroup.save(vm.customerGroup, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:customerGroupUpdate', result);
                $state.go('supplierPanel.editCustomerGroup', {id: result.id});

                loadAll();

            }

        }

    }
})();
